export const ENTIRE_ROUTE_DIRECTION_ID = 'all';
export const ENTIRE_ROUTE_LABEL = 'Entire Route';

export interface DirectionTripOption {
    tripId: string;
    shortTripId?: string;
    friendlyName?: string;
    tripHeadsign?: string;
}

export interface DirectionCatalogOption {
    id: string;
    displayName: string;
    internalId?: string;
    internalIds: string[];
    trips: DirectionTripOption[];
}

const toShortTripId = (tripId?: string): string => {
    const value = String(tripId ?? '').trim();
    if (!value) return '';
    const parts = value.split('_', 3);
    return parts.length === 3 ? parts[2] : value;
};

export function mergeDirectionTrips(directions: DirectionCatalogOption[]): DirectionTripOption[] {
    const byKey = new Map<string, DirectionTripOption>();
    directions.forEach(direction => {
        (direction.trips || []).forEach(trip => {
            const fullTripId = String(trip.tripId || '').trim();
            const shortId = String(trip.shortTripId || toShortTripId(fullTripId)).trim();
            const key = shortId || fullTripId;
            if (!key || byKey.has(key)) {
                return;
            }
            byKey.set(key, {
                tripId: fullTripId || key,
                shortTripId: shortId || undefined,
                friendlyName: trip.friendlyName,
                tripHeadsign: trip.tripHeadsign,
            });
        });
    });
    return Array.from(byKey.values());
}

export function buildEntireRouteDirectionOption(directions: DirectionCatalogOption[]): DirectionCatalogOption {
    return {
        id: ENTIRE_ROUTE_DIRECTION_ID,
        displayName: ENTIRE_ROUTE_LABEL,
        internalId: '',
        internalIds: [],
        trips: mergeDirectionTrips(directions),
    };
}

export function prependEntireRouteDirectionOption(directions: DirectionCatalogOption[]): DirectionCatalogOption[] {
    if (directions.length < 2) {
        return directions;
    }
    return [buildEntireRouteDirectionOption(directions), ...directions];
}

export function isEntireRouteDirection(direction: DirectionCatalogOption | null | undefined): boolean {
    return direction?.id === ENTIRE_ROUTE_DIRECTION_ID;
}
